 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import {useMemo} from 'react'


const useSpotlightVisibleReflections = (
  reflections,
  spotlightSearchQuery,
  reflectionIdsToHide
) => {
  return useMemo(() => {
    const visibleReflections = reflections.filter(({id}) => !_optionalChain([reflectionIdsToHide, 'optionalAccess', _ => _.includes, 'call', _2 => _2(id)]))

    if (spotlightSearchQuery && visibleReflections.length > 1) {
      const spotlightSearchQueryLower = spotlightSearchQuery.toLowerCase()
      const matchIndex = visibleReflections.findIndex((reflection) => {
        const textLower = reflection.plaintextContent.toLowerCase()
        return textLower.indexOf(spotlightSearchQueryLower) !== -1
      })

      if (matchIndex > 0) {
        const matchingReflection = visibleReflections.splice(matchIndex, 1)[0]
        visibleReflections.unshift(matchingReflection)
      }
    }

    return visibleReflections
  }, [reflections, reflectionIdsToHide, spotlightSearchQuery])
}

export default useSpotlightVisibleReflections
